<template>
	<common-card class="omapi-personalization__rules">
		<personalization-category
			v-for="category in categoriesToShow"
			:key="category.slug"
			:search="search"
			@clearSearch="$emit('clearSearch')"
			:category="category"
			:rules="rulesToShow(category.slug)"
		/>
	</common-card>
</template>

<script>
import { appData } from '@/utils'

export default  {
	props : {
		categories : {
			required : true,
			type     : Array,
		},
		filter : {
			default : 'popular',
		},
		search : {
			default : '',
		},
	},
	computed : {
		rules () {
			const d = appData.get('rulesetData')
			return [
				...d.rules,
				...d.wooCommerceRules,
			]
		},
		categoriesToShow () {
			if (this.search) {
				return [
					{
						slug        : 'search',
						displayName : `Search Results for &lsquo;${this.search}&rsquo;`,
						order       : 1,
					},
				]
			}

			if (this.filter) {
				return this.categories.filter(cat => this.filter === cat.slug)
			}

			// If no search or filter, show all the categories on the page
			return this.categories
		},
	},
	methods : {
		rulesToShow (slug) {
			return this.search
				? this.searchRules(this.search)
				: this.filteredRules(slug)
		},
		filteredRules (filter) {
			return filter
				? this.rules.filter(r => r.ruleType.includes(filter))
				: this.rules
		},
		searchRules (searchTerm) {
			if (!searchTerm) {
				return this.rules
			}

			searchTerm = searchTerm.toLowerCase()
			return this.rules.filter((rule) => {
				const toSearch = [
					rule.friendlyText.toLowerCase(),
					rule.helpText.toLowerCase(),
					rule.id.toLowerCase(),
					rule.keywords.join('|'),
				].join('|')

				return toSearch.includes(searchTerm)
			})
		},
	},
}
</script>
